(function () {
  // Standalone sticky "Add to Cart" bar for the custom rd-* product section. Unlike a
  // typical sticky bar, this one does NOT submit the cart itself -- clicking it just
  // scrolls the page back up to the real [data-rd-add-to-cart] button/buy box, since
  // that's where variant selection, quantity, and the actual add-to-cart action live.

  var STYLE_ID = 'rd-sticky-atc-style';
  var bar = null;
  var wired = false;

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.rd-sticky-atc{position:fixed;left:0;right:0;bottom:0;z-index:9999;width:100%;' +
      'display:flex;align-items:center;justify-content:center;' +
      'min-height:40px;padding:0 16px;padding-bottom:env(safe-area-inset-bottom);' +
      'border:0;background:#0a0a0a;color:#ffffff;' +
      'font-family:"Jost",sans-serif;font-size:12px;font-weight:500;letter-spacing:.06em;text-transform:uppercase;' +
      'cursor:pointer;transform:translateY(100%);transition:transform 260ms ease;}' +
      '.rd-sticky-atc[data-visible="true"]{transform:translateY(0);}' +
      '.rd-sticky-atc[data-sold="true"]{opacity:.6;}';
    document.head.appendChild(style);
  }

  function buildBar() {
    if (bar) return bar;
    bar = document.createElement('button');
    bar.type = 'button';
    bar.className = 'rd-sticky-atc';
    bar.dataset.visible = 'false';
    document.body.appendChild(bar);
    return bar;
  }

  function setup(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var realButton = scope.querySelector('[data-rd-add-to-cart]');
    if (!realButton) return;

    var realForm = realButton.closest('form');

    injectStyle();
    var el = buildBar();

    function syncButtonState() {
      el.textContent = realButton.textContent.trim();
      el.dataset.sold = realButton.disabled ? 'true' : 'false';
    }

    syncButtonState();

    if (!wired) {
      wired = true;
      el.addEventListener('click', function () {
        var target = realForm || realButton;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    // Re-target the observer to the current real button each setup() call, since
    // shopify:section:load can replace it with a new element after a re-render.
    new MutationObserver(syncButtonState).observe(realButton, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      characterData: true,
      subtree: true
    });

    var footer = document.querySelector('footer');
    var isStuck = false;
    var hiddenByFooter = false;

    function show() {
      isStuck = true;
      el.dataset.visible = 'true';
    }
    function hide() {
      isStuck = false;
      el.dataset.visible = 'false';
    }

    // Track the button itself, not the whole .rd-form (which also spans the variant/size
    // pickers above it) -- observing the form meant the bar only appeared once that entire
    // tall block left the viewport, well after the button itself had scrolled past.
    var buyAreaObserver = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      if (!entry) return;
      if (!entry.isIntersecting && !isStuck) {
        var rect = entry.target.getBoundingClientRect();
        if (rect.bottom < 0) show();
      } else if (entry.isIntersecting && isStuck) {
        hiddenByFooter = false;
        hide();
      }
    });
    buyAreaObserver.observe(realButton);

    if (footer) {
      var footerObserver = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (!entry) return;
          if (entry.isIntersecting && isStuck) {
            hiddenByFooter = true;
            hide();
          } else if (!entry.isIntersecting && hiddenByFooter) {
            var rect = realButton.getBoundingClientRect();
            if (rect.bottom < 0) {
              hiddenByFooter = false;
              show();
            }
          }
        },
        { rootMargin: '200px 0px 0px 0px' }
      );
      footerObserver.observe(footer);
    }
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (!scope.querySelector('[data-rd-add-to-cart]')) return;
    setup(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
